export function createCollapsableTable(table_idx, table) {
  console.log('Init createCollapsableTable');

  const $t = $(table);
  const $thead_rows = $t.find('thead tr');
  const $tbody_rows = $t.find('tbody tr');

  let num_cols = 0;
  $t.find('colgroup col').each((idx, col) => {
    num_cols += col.span; // We take in count cols with `span` attr
  });

  // Table has no <col> (it's old markup), we cannot continue
  if (num_cols === 0) {
    console.error('[data-collapsable-table] : Table has no <col>s!');
    return;
  }

  // Initialice all the data-attrs
  $thead_rows.each((tr_idx, tr) => {
    const $tr_current = $(tr);

    $tr_current.find('th').each((th_idx, th) => {
      const $th = $(th);

      const real_idx = getRealThIdx(th);
      $th.attr('data-real-idx', real_idx);

      const tbody_idxs = [];
      if (th.hasAttribute('data-collapsable-col')) {
        for (let i = real_idx; i < real_idx + th.colSpan; i++) {
          tbody_idxs.push(i);
        }
        $th.attr('data-collapsable-tbody-idx', JSON.stringify(tbody_idxs));
      }

      // If has more than a single child
      // if (tbody_idxs.length > 1) {
      //   console.log('Add first of colspan:', $th.text().trim());
      //   for (let i = 1; i < tbody_idxs.length; i++) {
      //     const tbody_idx = tbody_idxs[i];
      //     console.log(tbody_idx);
      //   }
      // }
    });
  });

  // Mark first element of the subheaders (if any) colspan
  // $thead_rows.filter('.subheader').each((tr_idx, tr) => {
  //   const $tr_current = $(tr);
  //   $tr_current.find('th').each((th_idx, th) => {
  //     const $th = $(th);
  //   });
  // });

  // We set the visibility of `pre-collapsed cols`
  // In a separated loop so the DOM has time to updated
  $thead_rows.find('th.collapsed').each((th_idx, th) => {
    const $th = $(th);
    updateVisibility($th, true); // Force initial collapse
  });

  $t.find('th[data-collapsable-col]').on('click', (e) => {
    const $th = $(e.currentTarget);
    $th.toggleClass('collapsed');
    const is_collapsed = $th.hasClass('collapsed');
    updateVisibility($th, is_collapsed);
  });

  function updateVisibility($th, is_collapsed) {
    // Has any subcolumn to keep open?
    const idx_to_keep_open = $th.data('collapsable-col-keep-open') ?? [];
    const data_collapsable_tbody_idx = $th.data('collapsable-tbody-idx');
    let idx_to_hide = [];
    if (typeof data_collapsable_tbody_idx !== 'undefined') {
      idx_to_hide = data_collapsable_tbody_idx.filter((el, idx) => {
        if (!idx_to_keep_open.includes(idx + 1)) return el;
      });
    }

    // Add class to headers below the clicked one
    $th
      .closest('tr')
      .nextAll('tr')
      .each((tr_idx, next_tr) => {
        const $next_ths = $(next_tr).find('th');
        idx_to_hide.forEach((i) => {
          const $next_th = $next_ths.filter(`[data-real-idx=${i}]`);
          // $next_th.toggleClass('collapsed', is_collapsed);
          $next_th.toggleClass('visually-collapsed', is_collapsed);

          // Is there's only a child we do not collapse-visually pro prevent loosing left bar
          // if (idx_to_hide.length > 1) {
          //   $next_th.toggleClass('visually-collapsed', is_collapsed);
          // }
        });
      });

    // Add classes to the tbody tds
    idx_to_hide.forEach((i) => {
      // We need to +1 `i` cause jQuery's :nth-child starts in 0
      const _td = $tbody_rows.find(`td:nth-child(${i + 1})`);
      _td.toggleClass('visually-collapsed', is_collapsed);
    });
  }
}

function getRealThIdx(th) {
  var real_idx = 0;
  $(th)
    .prevAll('th')
    .each((idx, th) => {
      real_idx += th.colSpan;
    });
  return real_idx;
}
